ui-cms-quickfact {
  display: block;

  &.inverted {
    sd-quickfact::part(summary),
    sd-quickfact::part(summary-icon),
    sd-quickfact::part(content) {
      color: $sd-textColor-white;
    }
  }

  .quickfact-layout {
    &--left {
      display: flex;

      sd-icon {
        margin-right: $sd-spacing-4;
        flex-shrink: 0;
      }
    }

    &--summary {
      text-align: left;
      display: block;
      word-break: break-all;
    }
  }

  &.sd-icon {
    &--small {
      sd-icon {
        width: 3.5rem;
        height: 3.5rem;
      }
    }

    &--large {
      sd-icon {
        width: 5.625rem;
        height: 5.625rem;
      }
    }
  }

  .subline {
    font-size: $sd-fontSize-xl;
    line-height: 1.3;
    word-break: break-word;
  }

  .headline {
    margin-bottom: $sd-spacing-2;
  }

  &.layout-left {
    sd-quickfact::part(summary) {
      width: 100%;
    }
  }

  &.header {
    sd-quickfact::part(header) {
      padding-bottom: 0;
    }
  }
}
